import { render, staticRenderFns } from "./UserRequestMatchesModal.vue?vue&type=template&id=347a40d0&scoped=true&"
import script from "./UserRequestMatchesModal.vue?vue&type=script&lang=js&"
export * from "./UserRequestMatchesModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRequestMatchesModal.vue?vue&type=style&index=0&id=347a40d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a40d0",
  null
  
)

export default component.exports